import React, { useEffect, useState } from "react";
import "../Uppernav/Uppernav.css";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { getMyToken } from "../../getToken";


export default function Uppernav() {
  const [showLogout, setShowLogout] = useState(false);
  
  const [cartCount, setCartCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [notificationCount, setNotificationCount] = useState(0);

  const navigate = useNavigate();

  /* ===================== SEARCH ===================== */


useEffect(() => {
  const fetchCartCount = async () => {
    const token = localStorage.getItem("token");

    if (!token || token === "undefined" || token === "null") {
      setCartCount(0);
      setNotificationCount(0);
      return;
    }

    getNotificationCount();

    try {
      const res = await axios.get(`${BaseUrl}${BuyerServicesUrl.ShowCart}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const items = res.data?.data?.items || [];
      setCartCount(items.length);

    } catch (err) {
      if (err.response?.status === 404) {
        setCartCount(0);
        return;
      }
      setCartCount(0);
    }
  };

  fetchCartCount();

  const handler = (e) => {
    if (e.detail === "increment") {
      setCartCount((prev) => prev + 1);
    } else {
      fetchCartCount();
    }
  };

  window.addEventListener("cartUpdated", handler);
  window.addEventListener("authChanged", handler);

  return () => {
    window.removeEventListener("cartUpdated", handler);
    window.removeEventListener("authChanged", handler);
  };
}, []);

useEffect(() => {
  getNotificationCount();

  const handler = () => getNotificationCount();

  window.addEventListener("notificationUpdated", handler);

  return () => {
    window.removeEventListener("notificationUpdated", handler);
  };
}, []);
  /* ===================== LOGOUT ===================== */
//  const handleLogout = async () => {
//   try {
//     await axios.post(BaseUrl + "user/auth/logout", {}, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`
//       }
//     });

//     localStorage.clear();
//     setCartCount(0);   // 
//     navigate("/login");

//   } catch (error) {
//     console.log(error);
//   }
// };
const handleLogout = async () => {
  try {
    await axios.post(BaseUrl + "user/auth/logout", {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    localStorage.clear();
    setCartCount(0);
    window.dispatchEvent(new Event("authChanged")); 
    navigate("/login");

  } catch (error) {
    console.log(error);
  }
};
const handleSearch = () => {
  if (!searchValue.trim()) return;
  navigate(`/productlist?search=${searchValue}`);
};
// async function getNotificationCount() {
//     const token = localStorage.getItem("token"); 

//   if (!token) {
//     setNotificationCount(0);
//     return;
//   }

//   try {
//     const res = await axios.get(
//       "https://api.tokalnaja.com/api/count-unread-notifications",
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );

//     setNotificationCount(res.data.data.unread_count);
//   } catch (err) {
//     console.log(err);
//   }
// }

async function getNotificationCount() {
  const token = localStorage.getItem("token");

  if (!token) return;

  try {
    const res = await axios.get(
      BaseUrl + BuyerServicesUrl.GetCountNotification,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("🔔 SELLER COUNT:", res.data);

    setNotificationCount(
      res.data?.data?.unread_count || 0
    );

  } catch (err) {
    console.log(
      "❌ SELLER COUNT ERROR:",
      err.response?.data || err.message
    );
  }
}
  return (
    <>
      <div className="sellertn-uppernav">
        <div className="sellertn-uppernav-wrapper px-2 px-md-4">
          
          <img
            src={logo}
            alt="logo"
            className="tn-nav-logo"
            onClick={() => navigate("/")}
          />

          {/* ================= SEARCH ================= */}
          <div className="tn-search-box">
            <input
              type="text"
              placeholder="ابحث عن المنتج"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />

            <i
              className="fa fa-search tn-search-icon"
              onClick={handleSearch}
              style={{ cursor: "pointer" }}
            ></i>
          </div>

          {/* ================= LEFT ICONS ================= */}
          <div className="tn-left-icons">
            {/* <span className="tn-lang-btn">
              EN
            </span> */}
           
          {/* <i
  className="fa fa-bell tn-nav-icon"
  // onClick={() => navigate("/notification")}
//   onClick={async () => {
//   await getMyToken(); 
//   navigate("/notification");
// }}
onClick={async () => {
  if (Notification.permission === "default") {
    await getMyToken();
  } else if (Notification.permission === "denied") {
    alert("فعّل الإشعارات من إعدادات المتصفح");
    return;
  }

  navigate("/notification");
}}
  style={{ cursor: "pointer" }}
></i> */}
<div className="notification-wrapper" onClick={() => navigate("/notification")}>
  <i className="fa fa-bell tn-nav-icon"></i>

  {notificationCount > 0 && (
    <span className="notification-badge">
      {notificationCount}
    </span>
  )}
</div>
            {/*  CART */}
            <div
              className="cart-icon-wrapper pt-1"
              onClick={() => navigate("/cart")}
            >
              <i className="fa-solid fa-cart-arrow-down tn-nav-icon"></i>
              {cartCount > 0 && (
                <span className="cart-badge">{cartCount}</span>
              )}
            </div>

            {/* <i
              className="fa fa-user tn-nav-icon"
              onClick={() => setShowLogout(true)}
            > 
            </i> */}
            <i
  className="fa fa-user tn-nav-icon"
  onClick={() => {
    const token = localStorage.getItem("token");

    if (!token || token === "undefined" || token === "null") {
      navigate("/login");
    } else {
      navigate("/profileaccount");
    }
  }}
  style={{ cursor: "pointer" }}
></i>
          </div>
        </div>
      </div>

      {/* ================= LOGOUT MODAL ================= */}
      {showLogout && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <h3>هل تريد تسجيل الخروج ؟</h3>
            <button className="logout-confirm" onClick={handleLogout}>
              تسجيل الخروج
            </button>
            <button
              className="logout-cancel"
              onClick={() => setShowLogout(false)}
            >
              إلغاء
            </button>
          </div>
        </div>
      )}
    </>
  );
}